
define('text!templates/modules/calendar/calendar/calendar-component/item/item-move-modal.html',[],function () { return '<div class="calendar-item-move-body">\n    <div class="date-picker"></div>\n</div>\n';});

